// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + "posthog" + "." + "b56ad61f" + ".chunk.js";
};